import * as React from "react";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import Modal from "antd/es/modal/Modal";
import List from "antd/es/list";
import Link from "antd/es/typography/Link";
import Flex from "antd/es/flex";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import SwapOutlined from "@ant-design/icons/SwapOutlined";
import UserSwitchOutlined from "@ant-design/icons/UserSwitchOutlined";
import LockOutlined from "@ant-design/icons/LockOutlined";
import ExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";

export const Whitepaper: React.FunctionComponent = () => {
    const [isOpen, setIsOpen] = React.useState(false);

    return (
        <>
            <Link href="#" onClick={() => setIsOpen(true)}>
                Whitepaper
            </Link>
            <Modal
                open={isOpen}
                title={<Title level={1}>Liberstake whitepaper</Title>}
                maskClosable
                footer={null}
                onCancel={() => setIsOpen(false)}
                onClose={() => setIsOpen(false)}
                className="Whitepaper"
            >
                <Paragraph>A Simple, Secure, and Registration-Free Cross-Chain Exchange</Paragraph>

                <Flex gap="5px" align="center" className="Whitepaper__wrapper">
                    <InfoCircleOutlined />
                    <Title className="Whitepaper__subtitle" level={2}>Overview</Title>
                </Flex>
                <Paragraph>
                    <strong>LiberStake</strong> is a centralized exchange (CEX) built for speed, simplicity, and user privacy.
                    Our platform allows anyone to swap tokens between different blockchains without creating an account,
                    verifying identity, or giving up custody of their assets.
                </Paragraph>
                <Paragraph>
                    We use direct, on-chain payments through <strong>LLD</strong>, a third-party token, to process exchanges
                    securely and transparently.
                </Paragraph>

                <Flex gap="5px" align="center" className="Whitepaper__wrapper">
                    <SwapOutlined />
                    <Title className="Whitepaper__subtitle" level={2}>How It Works</Title>
                </Flex>
                <Paragraph>The exchange process is simple and streamlined:</Paragraph>
                <List
                    dataSource={[
                        {
                            title: "Choose Chains:",
                            value: "Select the blockchain you are sending from and the one you want to receive tokens on.",
                        },
                        {
                            title: "Enter Amount:",
                            value: "Input the amount you want to transfer. Our system calculates the expected amount you’ll receive.",
                        },
                        {
                            title: "Make Payment:",
                            value: "You’ll be redirected to your wallet to send a one-time payment in LLD.",
                        },
                        {
                            title: "Receive Tokens:",
                            value: "After confirming your payment, we send the corresponding tokens to your wallet on the destination chain.",
                        },
                    ]}
                    renderItem={({ title, value }) => (
                        <List.Item>
                            <List.Item.Meta title={title} />
                            {value}
                        </List.Item>
                    )}
                />

                <Flex gap="5px" align="center" className="Whitepaper__wrapper">
                    <UserSwitchOutlined />
                    <Title className="Whitepaper__subtitle" level={2}>No Sign-Up. No KYC. No Waiting.</Title>
                </Flex>
                <Paragraph>
                    There’s no need to register, submit documents, or wait for approval. Everything is handled automatically in a few simple steps.
                </Paragraph>

                <Flex gap="5px" align="center" className="Whitepaper__wrapper">
                    <LockOutlined />
                    <Title className="Whitepaper__subtitle" level={2}>Security and Custody</Title>
                </Flex>
                <Paragraph>
                    <strong>LiberStake does not hold user funds.</strong> Each transaction is processed individually:
                </Paragraph>
                <List
                    dataSource={[
                        <>You pay us in LLD through a one-time, on-chain transaction.</>,
                        <>We send your tokens directly to your wallet on the destination chain.</>,
                    ]}
                    renderItem={(item) => <List.Item>{item}</List.Item>}
                />
                <Paragraph>
                    There are no custodial wallets or pooled balances. This minimizes risk and keeps full control in your hands.
                </Paragraph>

                <Flex gap="5px" align="center" className="Whitepaper__wrapper">
                    <ExclamationCircleOutlined />
                    <Title className="Whitepaper__subtitle" level={2}>Important Notice</Title>
                </Flex>
                <Paragraph>
                    <strong>All transactions are final and irreversible.</strong> Because we don’t store user funds or manage third-party wallets,
                    <strong> we cannot recover funds if payment information is entered incorrectly.</strong>
                    Always double-check wallet addresses and amounts before confirming a transfer.
                </Paragraph>
            </Modal>
        </>
    );
};
